if (!customElements.get('cart-cross-sell')) {
  customElements.define(
    'cart-cross-sell',
    class CartCrossSell extends HTMLElement {
      constructor() {
        super();
        this.cart = this.closest('cart-drawer') || document.querySelector('cart-drawer') || document.querySelector('cart-items');
        this.button = this.querySelector('button');
        this.variantId = this.button.dataset.variantId;

        this.button.addEventListener('click', this.onClick.bind(this));
      }

      onClick(evt) {
        evt.preventDefault();
        if (this.button.getAttribute('aria-disabled') === 'true') return;

        this.button.setAttribute('aria-disabled', true);
        this.button.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('id', this.variantId);
        formData.append('quantity', 1);

        const sellingPlanId = this.button.dataset.sellingPlanId;
        if (sellingPlanId) {
          formData.append('selling_plan', sellingPlanId);
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.section || section.id)
          );
          formData.append('sections_url', window.location.pathname);
          if (this.cart.setActiveElement) {
            this.cart.setActiveElement(document.activeElement);
          }
        }

        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              console.error(response.message);
              return;
            }

            const buttonText = this.querySelector('.cart-cross-sell__button-text');
            if (buttonText) {
                buttonText.textContent = window.variantStrings ? window.variantStrings.addedToCart || 'Added' : 'Added';
            }
            
            publish(PUB_SUB_EVENTS.cartUpdate, {
              source: 'cart-cross-sell',
              productVariantId: this.variantId,
              cartData: response,
            });

            if (this.cart) {
              if (this.cart.tagName === 'CART-DRAWER') {
                setTimeout(() => {
                  this.cart.renderContents(response);
                }, 600);
              } else if (this.cart.tagName === 'CART-ITEMS') {
                setTimeout(() => {
                  this.cart.getSectionsToRender().forEach((section) => {
                    const elementToReplace =
                      document.getElementById(section.id).querySelector(section.selector) || document.getElementById(section.id);
                    
                    const parsedHtml = new DOMParser().parseFromString(response.sections[section.section || section.id], 'text/html');
                    const newContent = parsedHtml.querySelector(section.selector);
                    if (elementToReplace && newContent) {
                      elementToReplace.innerHTML = newContent.innerHTML;
                    }
                  });
                }, 600);
              }
            } else {
              // Trigger global recharge update if it exists
              if (window.Recharge && typeof window.Recharge.syncCart === 'function') {
                window.Recharge.syncCart();
              } else {
                 // Dispatch a general cart update event for Recharge
                 document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: response } }));
              }
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.button.classList.remove('loading');
            this.querySelector('.loading__spinner').classList.add('hidden');
            this.button.removeAttribute('aria-disabled');
          });
      }
    }
  );
}
